import React from 'react'
import "./Forms.css"

const Submit_button = (props) => {
  return ( <input className='submit-button' type='submit' value={props.value}/> )
}

export default Submit_button
